import {observable} from 'mobx'
import $ from 'jquery'
import Cookies from 'js-cookie'

import Status from 'lib/control/Status'

import XmlGeneratorResponse from './YmlGeneratorResponse'

const GENERATOR_URL = '?plugin=market&module=generator&action=generateYml'
const INFO_REQUESTS_QUEUE_SIZE_LIMIT = 1

let request_key = 1

export default class YmlGenerationController {
    profile_id

    process_id = null
    @observable is_completed = false
    @observable is_failed = false
    @observable error_message = ''
    @observable completion_percent = 0
    @observable exported_offers_count = 0
    @observable current_state_description = ''

    @observable status = Status.NONE

    info_requests_queue_size = 0
    last_request_key = 0
    profile_document = null

    constructor(profile_id) {
        this.profile_id = profile_id
    }

    async sendInitializationRequest() {
        this._resetState()

        this.status = Status.LOADING

        const data = {
            profile_id: this.profile_id,
            request_key: request_key++,
            _csrf: Cookies.get('_csrf'),
        }
        const response_raw = await this._performAjax(data)

        const response = new XmlGeneratorResponse(response_raw)

        if (response.is_invalid) {
            throw "initialization response is invalid"
        }

        this.process_id = response.process_id
        this.current_state_description = response.summary.current_state_description
    }

    async trySendInfoRequest() {
        if (this.info_requests_queue_size >= INFO_REQUESTS_QUEUE_SIZE_LIMIT) {
            return
        }

        this.info_requests_queue_size++

        try {
            const data = {
                processId: this.process_id,
                request_key: request_key++,
                _csrf: Cookies.get('_csrf'),
            }
            const response_raw = await this._performAjax(data)

            const response = new XmlGeneratorResponse(response_raw)

            if (response.is_invalid || response.is_lost) {
                this.is_completed = true
                this.is_failed = true
                this.error_message = response.error_message
            } else if (!this.is_completed && response.request_key > this.last_request_key) {
                this.is_completed = response.is_completed
                this.completion_percent = response.summary.percent
                this.exported_offers_count = response.summary.exported_offers_count
                this.current_state_description = response.summary.current_state_description
                this.last_request_key = response.request_key
                this.profile_document = response.profile_document
            }
        } catch (e) {
            this.is_completed = true
            this.is_failed = true
            this.error_message = 'error'

            this._resetStatus(Status.ERROR)
        }

        if (this.is_completed) {
            this.status = Status.SUCCESS
        }

        this.info_requests_queue_size--
    }

    getDescription() {
        const percent = parseFloat(this.completion_percent)
        if (Number.isNaN(percent)) {
            return this.current_state_description ? this.current_state_description : ''
        }

        return this.current_state_description
            ? `${percent.toFixed()}% — ${this.current_state_description.toLocaleLowerCase()}`
            : `${percent.toFixed()}%`
    }

    isCompleted() {
        return this.is_completed
    }

    _resetStatus(status) {
        this.status = status

        setTimeout(() => {
            this.status = Status.NONE
        }, 2000)
    }

    _resetState() {
        this.is_completed = false
        this.is_failed = false
        this.error_message = ''
        this.completion_percent = 0
        this.exported_offers_count = 0
        this.profile_document = null
    }

    _performAjax(data) {
        return $.ajax({
            url: GENERATOR_URL,
            method: 'POST',
            dataType: 'json',
            data: data,
        })
    }
}
